export function convertPixelsToPicks(pixels: number, nrPicksPerColorLine: number): number {
  return pixels * nrPicksPerColorLine;
}
